import { extensionOf } from '@components/Attachments/attachmentKind';
import { HTML_PREVIEW_MAX_BYTES } from './HtmlArtifact.constants';

const HTML_EXTENSIONS = new Set(['html', 'htm']);

export const canPreviewHtml = (name: string, fileSize: number, contentType = ''): boolean => {
  const mime = contentType.toLowerCase().split(';')[0].trim();
  const isHtml = mime === 'text/html' || HTML_EXTENSIONS.has(extensionOf(name));
  return isHtml && fileSize > 0 && fileSize <= HTML_PREVIEW_MAX_BYTES;
};
